<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/accountOwnerList">Customers</a></li>
      <li aria-current="page" class="breadcrumb-item active">Edit Customer</li>
    </ol>
  </nav>

  <div [hidden]="!errorMessage" class="invalid-feedback d-block shift-invalid-text">{{errorMessage}}</div>
  <div class="row mt-3">
    <div class="col">
      <div class="inner-box">
        <h2 class="text-black">Customer Details</h2>
        <div class="row mt-3">
          <div class="col-md-12 col-md-8">
            <div class="row">
              <div class="col-md-3 required">
                <div class="form-group">
                  <label class="control-label" for="companyName">Company Name</label>
                  <input (blur)="typeCompanyName()" [(ngModel)]="account.companyName"
                         [ngClass]="{'is-invalid':statusText1}" [ngModelOptions]="{standalone: true}"
                         class="form-control" id="companyName"
                         required type="text">
                  <div [hidden]="!statusText1"
                       class="invalid-feedback d-block shift-invalid-login">{{statusText1}}
                  </div>
                </div>
              </div>
              <div class="col-md-3 required">
                <div class="form-group ">
                  <label class="control-label" for="conactName">Contact Name</label>
                  <input (blur)="typeContactName()" [(ngModel)]="account.ownerName"
                         [ngClass]="{'is-invalid':statusText2}"
                         [ngModelOptions]="{standalone: true}" class="form-control text-transform: uppercase;"
                         id="conactName" required type="text">
                  <div [hidden]="!statusText2"
                       class="invalid-feedback d-block shift-invalid-login">{{statusText2}}
                  </div>
                </div>
              </div>
              <div *ngIf="account.accountType == 'DEMO_ACCOUNT'" class="col-md-3 required">
                <div class="form-group">
                  <label class="control-label" for="extendDate">Extend Date</label>
                  <input [(ngModel)]="account.expiryDate" [ngModelOptions]="{standalone: true}" class="form-control"
                         id="extendDate"
                         type="text" value="1">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <div class="control-label">Email</div>
                  <div><b>{{account.email}}</b></div>
                  <div [hidden]="!statusText3"
                       class="invalid-feedback d-block shift-invalid-login">{{statusText3}}
                  </div>

                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <div class="control-label">Phone Number</div>
                  <div><b>{{account.mobile}}</b></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col">
      <div class="inner-box">
        <div class="row">
          <h2 class="text-black"></h2>
          <div class="col-md-6" style="padding: 0px;">
            <label class="input_heads required"><b>Pancard </b><span class="text-danger">*</span><br>
              <input (change)="checkPanNo()" (ngModelChange)="account.panCardNumber = $event.toUpperCase()"
                     [(ngModel)]="account.panCardNumber" [ngClass]="{'service-error':panNoerrorMessage}"
                     class="form-control input-border-radius  mr-2"
                     id="pan" maxlength="10"
                     onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 48 && event.charCode <= 57 || event.charCode >= 97 && event.charCode <= 122"
                     placeholder="ABCDE1234F" type="text">
              <span *ngIf="panNoerrorMessage" class="text-danger"
                    style="position: absolute;"> {{panNoerrorMessage}}</span>
            </label>
          </div>

          <div class="col-md-6">
            <label [ngClass]="{'service-error':panCardPhotoError}" class="upload_kyc" style="">
              <input (change)="loadPancard($event)" [(ngModel)]="account.panCard" [ngModelOptions]="{standalone: true}"
                     id="pancard" type="file"/>
              <span *ngIf="!account.panCard || account.panCard == ''"><img alt="panCardPhoto"
                                                                           src="/./assets/images/Group_1645.svg"> Upload Pan Card</span>
              <span *ngIf="account.panCard"><img src="/./assets/images/Group_1646.svg"></span>
            </label>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <label class="input_heads"><b>Aadhar Card </b><span class="text-danger">*</span><br>
              <input [(ngModel)]="account.aadhartCardNumber" [ngClass]="{'service-error':aadharNumberError}"
                     [ngModelOptions]="{standalone: true}" class="mr-2"
                     id="aadharnumber"
                     maxlength="12" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                     placeholder="Enter Aadhar Card Number" type="text"/>
            </label>
          </div>

          <div class="col-md-6">
            <label [ngClass]="{'service-error':aadharPhotoError}" class="upload_kyc" style="">
              <input (change)="loadAadhar($event)" [(ngModel)]="account.aadharCard"
                     [ngModelOptions]="{standalone: true}"
                     id="aadharcard" type="file"/>
              <span *ngIf="!account.aadharCard || account.aadharCard == ''"><img alt="aadharPhoto"
                                                                                 src="/./assets/images/Group_1645.svg"> Upload Aadhar Card</span>
              <span *ngIf="account.aadharCard"><img src="/./assets/images/Group_1646.svg"></span>
            </label>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <label class="input_heads"><span>GST No.</span><br>
              <input [(ngModel)]="account.gstNumber" [ngModelOptions]="{standalone: true}"
                     placeholder="Enter ID Proof Number"
                     type="text"/>
            </label>
          </div>

          <div class="col-md-6">
            <label [ngClass]="{'service-error':mouError}" class="upload_kyc" style="">
              <input (change)="loadImage($event)" [(ngModel)]="account.mouDocument"
                     [ngModelOptions]="{standalone: true}"
                     id="mouDocument" type="file"/>
              <span *ngIf="!account.mouDocument || account.mouDocument == ''"><img alt="mouDocument"
                                                                                   src="/./assets/images/Group_1645.svg"> Upload MOU</span>
              <span *ngIf="account.mouDocument"><img src="/./assets/images/Group_1646.svg"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col">
      <div class="inner-box">
        <h2 class="text-black mb-3">Address</h2>
<!--
        <div class="row">
          <div class="col-6 required">
            <div class="form-group">
              <label class="control-label" for="addressType">Address Type</label>
              <select [(ngModel)]="accountCommAddress.addressType" [ngModelOptions]="{standalone: true}"
                      class="form-control"
                      id="addressType" required>
                <option *ngFor="let a of addressTypes" [ngValue]="a.config">{{a.config}}</option>
              </select>
              <div [hidden]="!statusText9" class="invalid-feedback d-block shift-invalid-login"
                   id="statusText9">{{statusText9}}
              </div>
            </div>
          </div>
        </div>
-->
        <div class="row">
          <div class="col-md-4">
            <div class="form-group mt-3">
              <label class="control-label">Address Type : {{accountCommAddress.addressType}} </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-8 col-md-12">
            <div class="row">
              <div class="col-md-4 required">
                <div class="form-group">
                  <label class="control-label" for="Address">Address1</label>
                  <input (blur)="typeAddress()" [(ngModel)]="accountCommAddress.address1"
                         [ngClass]="{'is-invalid':statusText4}" [ngModelOptions]="{standalone: true}"
                         class="form-control" id="Address"
                         required type="text">
                  <div [hidden]="!statusText4"
                       class="invalid-feedback d-block shift-invalid-login">{{statusText4}}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group ">
                  <label class="control-label" for="Address2">Address2</label>
                  <input [(ngModel)]="accountCommAddress.address2" [ngModelOptions]="{standalone: true}"
                         class="form-control" id="Address2"
                         required type="text">
                </div>
              </div>
              <div class="col-md-4 required">
                <div class="form-group">
                  <label class="control-label">City</label>
                  <ng-select (blur)="typeCity()" [(ngModel)]="accountCommAddress.city"
                             [ngClass]="{'is-invalid':statusText6}" [ngModelOptions]="{standalone: true}"
                             id="city" placeholder="City" [items]="citiesList" [addTag]="true"
                             required type="text">
                  </ng-select>
                  <div [hidden]="!statusText6"
                       class="invalid-feedback d-block shift-invalid-login">{{statusText6}}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 required">
                <div class="form-group">
                  <label class="control-label">State</label>
                  <ng-select (blur)="typeState()" [(ngModel)]="accountCommAddress.state" [items]="statesList"
                             [ngClass]="{'is-invalid':statusText7}"
                             [ngClass]="{'service-error':statusText7}"
                             [ngModelOptions]="{standalone: true}"
                             id="State"
                             placeholder="State">
                  </ng-select>
                  <div [hidden]="!statusText7"
                       class="invalid-feedback d-block shift-invalid-login">{{statusText7}}
                  </div>
                </div>
              </div>
              <div class="col-md-4 required">
                <div class="form-group">
                  <label class="control-label" for="zip">Zip</label>
                  <input (blur)="typeZip()" [(ngModel)]="accountCommAddress.zip" [ngClass]="{'is-invalid':statusText8}"
                         [ngModelOptions]="{standalone: true}" appOnlyNumbers maxlength="6" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                         class="form-control" id="zip" required (change)="changeCityAndState()"
                         type="text">
                  <div [hidden]="!statusText8"
                       class="invalid-feedback d-block shift-invalid-login">{{statusText8}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col">
      <div class="inner-box">
        <h2 class="text-black mb-3">COD Payment Preferences</h2>
        <div class="row">
          <label>Payment will be done after following number of days from product delivered</label>
        </div>
        <div class="row">
          <div class="col-md-3">
            <select id="days" [(ngModel)]="noOfDays" class="form-control"
                    [ngModelOptions]="{standalone: true}" placeholder="Select Days" required>
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
              <option>6</option>
              <option>7</option>
              <option>8</option>
              <option>9</option>
              <option>10</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button class="btn btn-cancel-prime" routerLink="/admin/accountOwnerList" type="reset">Cancel</button>
      <button (click)="createAccountOwner()" class="btn btn-orange-prime ml-2" type="submit">Save</button>
    </div>
  </div>
</div>
